import { z } from 'zod';

export enum TransporterType {
  THIRD_PARTY = 'Third-Party',
  REPUBLIC_SERVICES = 'Republic Services',
}

export const transporterTypeOptions = [
  TransporterType.THIRD_PARTY,
  TransporterType.REPUBLIC_SERVICES,
] as const;

export const TransporterTypeSchema = z.enum(transporterTypeOptions);

export type TransporterTypeOptions = z.infer<typeof TransporterTypeSchema>;
